import { render } from "./SingleCoin.vue?vue&type=template&id=72b2a29c"
import script from "./SingleCoin.vue?vue&type=script&lang=js"
export * from "./SingleCoin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__